export const getRegisterInfo = (state) => {
  const { groups, user, showPassword, marketingTextView } = state;
  return { groups, user, showPassword, marketingTextView };
};
